<div class="circle-loader" [ngClass]="{'load-complete': currentState !== responseState.LOADING,
                'load-success': currentState === responseState.SUCCESS,
                'load-failure': currentState === responseState.ERROR}">
    <div class="draw" [ngClass]="{'checkmark': currentState === responseState.SUCCESS, 
                'error': currentState === responseState.ERROR}"></div>
</div>